/**
 * Core Types
 *
 * Contains all type definitions used throughout the AlphaLend SDK:
 * - Protocol-specific types and interfaces
 * - Transaction parameter types
 * - Response types for various operations
 * - Type guards and type utilities
 * - Enums for protocol states and options
 * - Blockchain-specific type mappings
 */
/**
 * Special constant for maximum u64 value (2^64 - 1)
 * Used to indicate withdrawing all collateral when passed as the amount parameter
 * in withdraw operations.
 */
export const MAX_U64 = 18446744073709551615n;
//# sourceMappingURL=types.js.map